import { companyService } from '../../services/companyService'
import * as actionTypes from './ActionTypes'

export const getMycompanySuccess = myCompany => {
  return {
    type: actionTypes.GET_MY_COMPANY_SUCCESS,
    payload: {
      myCompany,
    },
  }
}

export const getMyCompanyProductsSuccess = products => {
  return {
    type: actionTypes.GET_MY_COMPANY_PRODUCTS_SUCCESS,
    payload: { products },
  }
}

export const clearCompanyRedux = () => {
  return {
    type: actionTypes.CLEAR_COMPANY_REDUX,
  }
}

export const getMyCompany = () => async dispatch => {
  const response = await companyService.getMycompany()
  if (response.isOk && response.data) {
    dispatch(getMycompanySuccess(response.data))
  }
}

export const getMyCompanyProducts = () => async dispatch => {
  const response = await companyService.getMyCompanyProducts({
    perPage: 100,
  })
  if (response.isOk && response.data) {
    dispatch(getMyCompanyProductsSuccess(response.data.data))
  }
}

export const saveVisitedCompany = companyId => {
  const visitData = { companyId, visitTime: Date.now() }

  return {
    type: actionTypes.SAVE_VISITED_COMPANY,
    payload: {
      visitData,
    },
  }
}

export const deleteVisitedCompanies = () => {
  return {
    type: actionTypes.DELETE_VISITED_COMPANIES,
  }
}

export const getHomePageCompaniesSuccess = companies => {
  return {
    type: actionTypes.GET_HOME_PAGE_COMPANIES_SUCCESS,
    payload: {
      companies,
    },
  }
}

export const getHomePageCompanies = () => async dispatch => {
  const response = await companyService.getHomePageCompanies()
  if (response.isOk) {
    dispatch(getHomePageCompaniesSuccess(response.data))
  }
}
